import { AppointmentSchedulingConfiguration } from '../config/appointment_scheduling_configuration';

export class LocalStorageServant {
  storageType: string;
  _storage: any;

  constructor(private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration) {
    this.storageType = this.ngAppointmentSchedulingConfiguration.config.storage as string;
    this._storage = window[this.storageType];
  }
  getItem(key: string): any {
    return JSON.parse(this._storage.getItem(key));
  }
  setItem(key: string, value: any): void {
    this._storage.setItem(key, JSON.stringify(value));
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/local_storage_servant.ts